import store from "../store";
import Constants from "../config/constants";
import { serviceHqManpowerList } from "../services/HqManpower.service";

export const FETCH_INIT = "FETCH_INIT_HQ_MANPOWER_ALLOTMENT";
export const FETCHED = "FETCHED_HQ_MANPOWER_ALLOTMENT";
export const FETCHED_FAIL = "FETCHED_FAIL_HQ_MANPOWER_ALLOTMENT";
export const FETCHED_FILTER = "FETCHED_FILTER_HQ_MANPOWER_ALLOTMENT";
export const FETCH_NEXT = "FETCH_NEXT_HQ_MANPOWER_ALLOTMENT";
export const FILTER = "FILTER_HQ_MANPOWER_ALLOTMENT";
export const RESET_FILTER = "RESET_FILTER_HQ_MANPOWER_ALLOTMENT";
export const SET_SORTING = "SET_SORTING_HQ_MANPOWER_ALLOTMENT";
export const SET_FILTER = "SET_FILTER_HQ_MANPOWER_ALLOTMENT";
export const SET_PAGE = "SET_PAGE_HQ_MANPOWER_ALLOTMENT";
export const CHANGE_PAGE = "CHANGE_PAGE_HQ_MANPOWER_ALLOTMENT";
export const CHANGE_STATUS = "CHANGE_STATE_HQ_MANPOWER_ALLOTMENT";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_HQ_MANPOWER_ALLOTMENT";
export const CREATE_DATA = "CREATE_HQ_MANPOWER_ALLOTMENT";
export const UPDATE_DATA = "UPDATE_HQ_MANPOWER_ALLOTMENT";
export const DELETE_ITEM = "DELETE_HQ_MANPOWER_ALLOTMENT";

export function actionFetchHqManpower(index = 1, sorting = {}, filter = {}) {
  const request = serviceHqManpowerList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}


export function actionSetPageHqManpower(page) {
  const stateData = store.getState().hq_manpower;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;
  
  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchHqManpower(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
